import { NextSeo } from 'next-seo';
import dynamic from 'next/dynamic';
import React from 'react';
import OtherMemes from '../components/OtherMemes';
import PageHeader from '../components/PageHeader';
import config from '../config';

const TheMemeGeneratorPage = dynamic(() => import('../components/TheMemeGeneratorPage'), {
  ssr: false,
});

function Page() {
  const title = `Shitty Meme Generator - ${config.siteName}`;
  const description = `Create memes using your Shitty Kitties.`;

  return (
    <>
      <NextSeo title={title} description={description} />
      <div className='pb-12 md:pb-48 bg-bg'>
        <PageHeader
          heading={'Shitty Meme Generator'}
          description={description}
          docsLink='https://docs.shittykitties.art/website-utilities/shitty-costumes'
          fullWidth
        />
        <div className='px-4 lg:mx-auto lg:px-8 max-w-[90rem]'>
          <TheMemeGeneratorPage />
          <OtherMemes />
        </div>
      </div>
    </>
  );
}

export default Page;
